import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { itemsNotEqual } from "../../utils/helpers";
import SearchButtons from "./SearchButtons";
import Messaging from "../Common/Messaging";

class SearchStandard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  hasInteracted(initialState, currentState) {
    return itemsNotEqual(initialState, currentState, " has-interacted");
  }

  renderButtons() {
    //show desktop buttons
    if (this.props.device === "desktop") {
      return (
        <SearchButtons
          buttonId="resetSearch"
          buttonClassList="btn-primary btn-child-search__clearall"
          onClickMethod={(e)=>{this.props.handleSearchReset();this.props.toggleSearch(e);}}
          buttonText="Clear All"
        />
      );
    } else {
      return (
        <React.Fragment>
          <SearchButtons
            buttonId=""
            buttonClassList="btn-ghost-orange btn-child-search__cancel"
            onClickMethod={(e)=>{e.preventDefault();this.props.handleSearchReset(true);}}
            buttonText="Clear"
          />
          <SearchButtons
            buttonId=""
            buttonClassList="btn-primary btn-child-search__apply"
            onClickMethod={(e)=>this.props.toggleSearch(e)}
            buttonText="Apply"
          />
        </React.Fragment>
      );
    }
  }

  disableButton(element, disabled) {

  }

  render() {
    const {
      uiHasInteracted,
      initialState,
      searchQuery,
      countriesList,
      handleSearch,
      handleSearchReset,
      generateNumbers,
      selectValues,
      renderMessage,
      enableClearAll,
      ADPSearch,
      projectDescription
    } = this.props;
    return (
      <section className="children-search">
      {ADPSearch === true && this.props.device!=='desktop' ?<Messaging classList={'orange'} messageText={`You're currenty searching for children in ${projectDescription}`} />: ''}
      {this.props.device!=='desktop'?renderMessage(this.props):""}
        <form id="sponsorship-search" className="wvus-grid children-search-grid">
          <div className="form-group" id="location-group">
            {<label htmlFor="Location">Location</label>}
            <select
              id="Location"
              className={"form-control" + this.hasInteracted(initialState.countryCodes, uiHasInteracted.countryCodes)}
              onChange={(e) => {
                handleSearch(e.target.value === "" ? null : e.target.value, "countryCodes", searchQuery);
                this.setState({ countryName: e.target.options[e.target.selectedIndex].text });
                enableClearAll(true);
              }}
              disabled={uiHasInteracted.disabled===true || ADPSearch === true ? true:false }
              value={
                Array.isArray(searchQuery.countryCodes) && searchQuery.countryCodes.length > 0
                  ? searchQuery.countryCodes
                  : ""
              }
            >
              <option value="">No Preference</option>
              {/* <option value="">Worldwide</option> */}
              {countriesList}
            </select>
            
          </div>

          <div className="form-group" id="gender-group">
            {<label htmlFor="Gender">Gender</label>}
            <select
              id="Gender"
              className={"form-control" + this.hasInteracted(initialState.gender, uiHasInteracted.gender)}
              onChange={(e) => {
                handleSearch(e.target.value, "gender", searchQuery);
                enableClearAll(true);
              }}
              value={searchQuery.gender}
              disabled={uiHasInteracted.disabled}
            >
              <option value="">No Preference</option>
              <option value="M">Boy</option>
              <option value="F">Girl</option>
            </select>
          </div>

          <div className="form-group" id="age-group">
            {<label htmlFor="Age">Age</label>}
            <select
              id="Age"
              className={"form-control" + this.hasInteracted(initialState.minimumAge, uiHasInteracted.minimumAge)}
              onChange={(e) => {
                handleSearch(e.target.value, ["minimumAge", "maximumAge"], searchQuery);
                enableClearAll(true);
              }}
              value={searchQuery.maximumAge}
              disabled={uiHasInteracted.disabled}
            >
              <option value="">No Preference</option>
              <option value="0">less than 1</option>
              {selectValues(generateNumbers(1, 14))}
            </select>
          </div>

          <div className="form-group" id="month-group">
            {<label htmlFor="Month">Birth&nbsp;Month</label>}
            <select
              id="Month"
              className={
                "form-control" + this.hasInteracted(initialState.minimumBirthMonth, uiHasInteracted.minimumBirthMonth)
              }
              onChange={(e) => {
                handleSearch(e.target.value, ["minimumBirthMonth", "maximumBirthMonth"], searchQuery);
                enableClearAll(true);
              }}
              value={searchQuery.maximumBirthMonth}
              disabled={uiHasInteracted.disabled}
            >
              <option value="">No Preference</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>

          <div className="form-group" id="day-group">
            {<label htmlFor="Day"> Birth Day</label>}
            <select
              id="Day"
              className={
                "form-control" +
                this.hasInteracted(initialState.minimumBirthDayOfMonth, uiHasInteracted.minimumBirthDayOfMonth)
              }
              onChange={(e) => {
                handleSearch(e.target.value, ["minimumBirthDayOfMonth", "maximumBirthDayOfMonth"], searchQuery);
                enableClearAll(true);
              }}
              disabled={uiHasInteracted.disabled}
              value={searchQuery.maximumBirthDayOfMonth}
            >
              <option value="">No Preference</option>
              {selectValues(generateNumbers(1, 31))}
            </select>
          </div>
          {this.renderButtons()}
        </form>
        {ADPSearch === true && this.props.device==='desktop' ?<Messaging classList={'orange'} messageText={`You're currenty searching for children in ${projectDescription}`} />: ''}
        {this.props.device==='desktop'?renderMessage(this.props) :""}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
    formRequest: state.children,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // getChildren: getChildren,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(SearchStandard);
